module.exports = __webpack_public_path__ + "img/1160_MILR_Website_Heritage_03.131b07c9.jpg";